import React from 'react';

import { config } from 'data';
import { useLang } from 'hooks';
import { World } from 'components/icons';
import { CardView } from 'components/layout';
import { Form, Select } from 'components/ui';

const ProfileLanguage = () => {
  const lang = useLang();

  return (
    <CardView
      title={lang.get('profile.language.title')}
      caption={lang.get('profile.language.caption')}
    >
      <Form.Item style={{ marginBottom: 0 }}>
        <Select
          placeholder={lang.get('common.form.language.placeholder')}
          value={lang.locale}
          options={config.LOCALES.map((locale) => ({
            value: locale,
            label: lang.get(`common.languages.${locale}`),
          }))}
          prefix={<World />}
          onChange={lang.changeLocale}
        />
      </Form.Item>
    </CardView>
  );
};

export default ProfileLanguage;
